export default __webpack_public_path__ + "static/media/signin_banner_02.888397a3.jpg";